/* src/components/question-attachments/question-attachments.component.scss */
.select-answer,
.ng-dropdown-panel {
  z-index: calc(var(--vwui--zindex--select) - 10);
}
.image-file-upload__image-container,
.image-file-upload__dropping-container {
  position: relative;
  height: 102px;
  background-image: url("./media/document-4HK6UKHM.svg");
  background-repeat: no-repeat;
  background-position: center 15px;
  background-size: auto 46px;
  border-radius: 5px;
  border: 1px solid var(--vwui-color-neutral-3);
}
.image-file-upload__image-container p,
.image-file-upload__dropping-container p {
  text-align: center;
  position: absolute;
  width: 100%;
  bottom: 15px;
  font-size: 0.9em;
  font-weight: 500;
}
/*# sourceMappingURL=question-attachments.component-6QFQVCM3.css.map */
